// Категория: чистые хелперы, тексты для пользователя.
//
// Отделены от downloadContracts.js намеренно: там форма данных для сети и аналитики,
// здесь — то, что читает человек. Смешивать их в одном «файле общих штук» значит
// получить свалку, в которую по инерции складывают следующее общее.
import { NO_FORMATS_REASON, buildNoFormatsResult } from './downloadContracts';

// маппинг причины в сообщение раньше дублировался в обоих компонентах
const FAILURE_MESSAGES = {
    [NO_FORMATS_REASON.NO_CONVERTER]: 'This format needs a converter that failed to load',
    [NO_FORMATS_REASON.BLOCKED]: 'The download link was rejected',
    [NO_FORMATS_REASON.MALFORMED]: 'The server sent an unexpected response',
    [NO_FORMATS_REASON.FAILED]: 'The download could not be started',
};

/**
 * Сообщение по умолчанию для причины отказа. Вызывающий может дописать своё
 * уточнение, но базовый текст один на оба компонента.
 * @param reason {string} - значение NO_FORMATS_REASON
 * @param suffix {string} - необязательное продолжение фразы
 * @returns {string}
 */
function downloadFailureMessage(reason, suffix = '') {
    const base = FAILURE_MESSAGES[reason] || 'The download could not be started';
    return suffix ? `${base}. ${suffix}` : base;
}

/**
 * Отказ скачивания в том виде, в каком его показывают и отправляют в аналитику.
 * Текст и result строятся вместе, чтобы не разойтись между двумя компонентами.
 *
 * Лежит здесь, а не рядом со скачиванием: этим пользуется миксин, а тянуть ради
 * пары чистых строк модуль с window.LocalConverter и DOM он не должен.
 * @param reason {string} - значение NO_FORMATS_REASON
 * @param suffix {string} - необязательное продолжение фразы
 * @returns {{message: string, result: Object}}
 */
export function buildFailurePayload(reason, suffix = '') {
    return {
        message: downloadFailureMessage(reason, suffix),
        result: buildNoFormatsResult(null, reason),
    };
}

